<template>
	<div>
		<div class="card">
			<div class="card-header color-yellow">Transakcie</div>
			<div class="card-body pt-3 px-0">
				<Loading v-if="loading" class="mt-2 mb-1"/>
				<data-grid
						:items="items"
						:columns="columns"
						:on-detail-open="loadDetail"
						ref="transactions-data-grid"
						v-else
				>
					<template slot="value" slot-scope="{ item }">
						<price :value="item.value"/>
					</template>
					<template slot="date" slot-scope="{ item }">
						{{ item.date | date }}
					</template>
					<template slot="detail" slot-scope="{ item }">
						<Loading v-if="!item.detail" class="mb-5 p-5"/>
						<div class="my-3" v-if="item.detail">
							<strong>Podrobnosti</strong>
							<div class="details-wrapper mt-2">
								<div class="" v-for="(col, i) in detailColumns" :key="i">
									<div class="row" v-if="col.slug in item.detail">
										<div class="col-md-3">{{ col.name }}:</div>
										<div class="col-md-9" v-if="col.type === 'percent'">
											{{ item.detail[col.slug] | number }} %
										</div>
										<div class="col-md-9" v-else>
											{{ item.detail[col.slug] }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</data-grid>
				<Loading v-if="!loading && loadingNext" class="mt-2 mb-1"/>
				<div class="mt-4 text-center" v-if="items.length % 10 === 0">
					<button type="button" class="btn btn-warning" @click="nextPage()">
						<span>Načítať ďalšie</span>
					</button>
				</div>
			</div>
		</div>

		<div class="mt-3 text-right" v-if="!loading">
			<button class="btn btn-highlighted btn-warning" @click="exportToXls">Exportovať</button>
		</div>
	</div>
</template>

<script>
import DataGrid from "../../../components/DataGrid";
import Loading from "../../../components/Loading";
import Price from "../../../components/price";
import transactions from "@/store/modules/transactions";
import {token} from "../../../store/modules/account";
import {prepareQueryParameters} from "../../../store/api";

export default {
	name: "List",
	components: {
		Price,
		Loading,
		DataGrid
	},
	// props: {
	//   portfolio: {
	//     type: String | null,
	//     required: false,
	//     default: null
	//   }
	// },
	watch: {
		portfolio() {
			this.$store.commit("transactions/resetTransactions");
			this.page = 1;
			this.loadData();
		},
		from() {
			this.page = 1;
			this.loadData();
		},
		to() {
			this.page = 1;
			this.loadData();
		},
		currentFilter: {
			handler: function () {
				this.$store.commit("transactions/resetTransactions");
				this.page = 1;
				this.loadData();
			},
			deep: true
		}
	},
	computed: {
		items() {
			return this.$store.state.transactions.transactions;
		},
		portfolio() {
			return this.$store.state.portfolio.selected;
		},
		loading() {
			return this.$store.state.transactions.loadingList;
		},
		loadingNext() {
			return this.$store.state.transactions.loadingNext;
		},
		from() {
			return this.$store.state.transactions.from;
		},
		to() {
			return this.$store.state.transactions.to;
		},
		currentFilter() {
			return this.$store.state.transactions.transactionsValueFilter;
		}
	},
	mounted() {
		this.$store.commit("transactions/resetTransactions");
		this.loadData();
	},
	methods: {
		loadData() {
			this.$store.commit("transactions/resetTransactionDetails");
			this.$store.dispatch("transactions/transactions", {
				page: this.page,
				append: this.append,
				investmentStrategyId: this.portfolio,
				from: this.from,
				to: this.to,
				valueFrom:
						this.currentFilter.from === "" ? null : this.currentFilter.from,
				valueTo: this.currentFilter.to === "" ? null : this.currentFilter.to
			});
			this.$refs['transactions-data-grid'].resetOpenedIndex();
		},
		loadDetail(transaction, index) {
			this.$store.dispatch("transactions/transactionDetail", {
				id: transaction.id,
				date: transaction.date,
				index
			});
		},
		nextPage() {
			this.page += 1;
			this.append = true;
			this.loadData();
			this.append = false;
		},
		exportToXls() {
			const params = {
				investmentStrategyId: this.portfolio,
				from: this.$store.state.transactions.from,
				to: this.$store.state.transactions.to,
				valueFrom: this.$store.state.transactions.transactionsValueFilter.from,
				valueTo: this.$store.state.transactions.transactionsValueFilter.to,
				token: token(),
        clientToken: this.$store.state.account.tempUser.token
			};

			window.open(process.env.VUE_APP_API_LINK + `transactions/export-transactions.xlsx?${prepareQueryParameters(params)}`);
		},
	},
	data() {
		return {
			page: 1,
			append: false,
			columns: [
				{
					name: "Dátum transakcie",
					slug: "date"
				},
				{
					name: "Portfólio",
					slug: "portfolio"
				},
				{
					name: "Suma",
					slug: "value",
					thClass: "text-right"
				},
				{
					name: "Mena",
					slug: "currency"
				},
				{
					name: "Popis",
					slug: "type"
				},
				{
					name: "Poznámka",
					slug: "note"
				}
			],
			detailColumns: [
				{
					name: "Banka",
					slug: "bank",
					type: "string"
				},
				{
					name: "Mena",
					slug: "currency",
					type: "string"
				},
				{
					name: "Typ",
					slug: "feeType",
					type: "string"
				},
				{
					name: "Aktívum",
					slug: "equity",
					type: "string"
				},
				{
					name: "ISIN",
					slug: "isin",
					type: "string"
				},
				{
					name: "Kurz",
					slug: "conversionRate",
					type: "percent"
				},
				{
					name: "Počet",
					slug: "amount",
					type: "number"
				}
			]
		};
	}
};
</script>

<style lang="scss"></style>
